import { TErrorNotification } from '@/components/ErrorInlineNotification/ErrorInlineNotification';
import { PdfViewer } from '@/components/pdfViewer';
import { useTranslation } from '@/i18n';
import {
  ButtonV2,
  IconLeft,
  IconRight,
} from '@moneyforward/ap-frontend-components';
import { SearchedApPayee } from 'ap-openapi';
import classnames from 'classnames/bind';
import { FC } from 'react';
import { usePreviewFile } from '../Hooks/usePreviewFile';
import { PdfHeader } from '../PdfHeader';
import styles from './index.module.scss';
const cx = classnames.bind(styles);

interface PreviewInstructionProps {
  currentPayee: number;
  totalPayees: number;
  onPreviewPreviousPayee: () => void;
  onPreviewNextPayee: () => void;
  hasPreviousPayee: boolean;
  hasNextPayee: boolean;
  currentPreviewPayee?: SearchedApPayee;
  setError?: TErrorNotification['setError'];
}

export const PreviewInstruction: FC<PreviewInstructionProps> = ({
  currentPayee,
  totalPayees,
  onPreviewPreviousPayee,
  onPreviewNextPayee,
  hasPreviousPayee,
  hasNextPayee,
  currentPreviewPayee,
  setError,
}) => {
  const { t } = useTranslation();

  const { pdfUrl } = usePreviewFile(currentPreviewPayee?.id || '', setError);

  const counterpartyCode = currentPreviewPayee?.counterparty_code || '';
  const payeeName = currentPreviewPayee?.name || '';
  const payeeCode = currentPreviewPayee?.code || '';

  return (
    <div className={cx('preview-instruction')}>
      <div className={cx('header')}>
        <div className={cx('header-left')}>
          <div className={cx('label')}>
            {t('export_instruction_pdf_preview')}
          </div>
        </div>
        <div className={cx('header-right')}>
          <div className={cx('page-info')}>
            {currentPayee}/{totalPayees} {t('export_instruction_pdf_page')}
          </div>
          <ButtonV2
            onClick={onPreviewPreviousPayee}
            isDisabled={!hasPreviousPayee}
            size='sm'
            isSecondary
            isTransparent
            leftIcon={<IconLeft size={16} />}
          >
            {t('export_instruction_pdf_back')}
          </ButtonV2>
          <ButtonV2
            isTransparent
            isSecondary
            // onClick={onPreviewNextPayee}
            onClick={() => onPreviewNextPayee()}
            isDisabled={!hasNextPayee}
            size='sm'
            rightIcon={<IconRight size={16} />}
          >
            {t('export_instruction_pdf_next')}
          </ButtonV2>
        </div>
      </div>
      <div className={cx('viewer')}>
        <PdfHeader
          payeeName={payeeName}
          counterpartyCode={counterpartyCode}
          payeeCode={payeeCode}
        />
        <PdfViewer src={pdfUrl} />
      </div>
    </div>
  );
};

PreviewInstruction.displayName = 'PreviewInstruction';
